<template>
    <section class="section-list">
        <header>{{ $t("chatbotv2.archive") }}</header>
        <div class="archives-list">
            <FilterTool
                v-model="cloneFilters"
                :getAllVisitorId="getAllVisitorId"
                :getConversationById="getConversationById"
            />
            <div class="archives-list-list" ref="msgContainer">
                <EmptyFilterResult v-if="!items.length && !loading" :clear-filters="() => (cloneFilters = {})" />
                <div
                    class="archives-list-item"
                    v-for="item of items"
                    :key="item._id"
                    :class="{ active: activeChatId === item._id }"
                    @click="onConversationSelected(item._id)"
                    :id="item._id"
                >
                    <div class="source"></div>
                    <div class="name">{{ item.fullname }}</div>
                    <div class="date">{{ createdTimeHumanize(item) }}</div>
                    <div class="cb_messages">
                        <span class="form" v-if="!item.messages.length">
                            <span class="cb_message">{{ $t("chatbotv2.noMessage") }}</span>
                        </span>
                        <span class="from" v-else v-for="message of item.messages" :key="message.uniqMessageId"
                            >{{
                                `${
                                    message.messageType === "chatbot"
                                        ? "B"
                                        : message.messageType === "visitor"
                                        ? "K"
                                        : "T"
                                }`
                            }}:<span class="cb_message">{{ message.description }}</span></span
                        >
                    </div>
                </div>
                <div v-if="loading">
                    <div class="col m-3" v-for="skeleton in 5">
                        <div class="row">
                            <div class="col">
                                <a-skeleton :active="true" :paragraph="{ rows: 0 }" />
                            </div>
                            <div class="col">
                                <a-skeleton :active="true" class="skeleton-date" :paragraph="{ rows: 0 }" />
                            </div>
                        </div>

                        <div class="row">
                            <a-skeleton :active="true" class="col skeleton-message-content" :paragraph="{ rows: 0 }" />
                            <a-skeleton :active="true" class="col skeleton-message-content" :paragraph="{ rows: 0 }" />
                            <a-skeleton :active="true" class="col skeleton-message-content" :paragraph="{ rows: 0 }" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-row align-items-center justify-content-center my-3">
                <a-button
                    :loading="loading"
                    v-if="showLoadMore"
                    @click="loadMore"
                    style="background: #f5f8fb"
                    class="w-50"
                    >{{ loading ? $t("chatbotv2.loading") : $t("chatbotv2.loadMore") }}
                </a-button>
            </div>
        </div>
    </section>
</template>

<script>
import moment from "moment";
import FilterTool from "./FilterTool";
import _ from "lodash";
import log2 from "../../../../../utils/log2";
import EmptyFilterResult from "./EmptyFilterResult";

const log = log2("ConversationList");
export default {
    name: "ConversationList",
    components: {
        FilterTool,
        EmptyFilterResult,
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        activeChatId: {
            type: String,
        },
        onConversationSelected: {
            type: Function,
            required: true,
        },
        loadMore: {
            type: Function,
            required: true,
        },
        filters: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        showLoadMore: {
            type: Boolean,
            default: false,
        },
        getAllVisitorId: {
            type: Function,
            default: () => {},
        },
        getConversationById: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            cloneFilters: _.cloneDeep(this.filters),
            remainMessageList: null,
            currentShowingMessageList: null,
            isFirstDataFetched: false,
        };
    },
    computed: {},
    methods: {
        createdTimeHumanize(row) {
            return moment(row.createdDate).calendar();
        },
        scrollLastItem() {
            const lastItem = _.last(this.items);
            log(" lastitem", lastItem);
            if (!!lastItem) {
                const element = document.getElementById(lastItem._id);
                log(" element", element);

                if (!!element) {
                    this.$nextTick(() => {
                        element.scrollIntoView({
                            behavior: "smooth",
                        });
                    });
                }
            }
        },
    },
    mounted() {},
    watch: {
        cloneFilters: {
            handler(newValue, oldValue) {
                log("cloneFilters", newValue, oldValue);
                if (!_.isEqual(this.filters, newValue)) {
                    this.$emit("on-filters-changed", newValue);
                }
            },
            deep: true,
        },
        loading(isLoading) {
            if (isLoading) {
                this.scrollLastItem();
            }
        },
    },
};
</script>

<style lang="scss">
.archives-list {
    .ant-skeleton-content {
        .ant-skeleton-title {
            margin-top: 0px !important;
            height: 10px !important;
            width: 20% !important;
        }

        .ant-skeleton-paragraph {
            margin-top: 14px !important;
        }
    }

    .skeleton-date {
        .ant-skeleton-content {
            .ant-skeleton-title {
                width: 50% !important;
                float: right !important;
                margin-right: 10px !important;
            }
        }
    }

    .skeleton-message-content {
        .ant-skeleton-content {
            .ant-skeleton-title {
                width: 15% !important;
            }
        }
    }
}
</style>
